
const digest = 'efa9a5802fef3cd89bca8c7ee2702f30fa4777bbfc8f9368f91e4dd249b464a1';
const classes = {"wrapper":"_wrapper_bqih0_1"};
const css = `._wrapper_bqih0_1 {
  padding: 24px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  